/**
 * Catalog of {{ namespace.field }} variables available to document templates,
 * grouped by the Liquid drop that backs them on the server. Inserting one drops
 * a `variable` ProseMirror node whose `name` attr is the dotted key — the same
 * shape DocumentGeneration::ProsemirrorRenderer turns back into `{{ name }}`.
 *
 * Keep this in sync with the drops in app/drops/*. Labels are display-only and
 * shown in Spanish to match the product domain (HR/legal documents in Mexico).
 */
export const VARIABLE_CATEGORIES = [
  {
    key: 'contact',
    label: 'Contacto',
    icon: 'i-lucide-user',
    variables: [
      {
        key: 'contact.name',
        label: 'Nombre completo',
        example: 'María González',
      },
      { key: 'contact.first_name', label: 'Nombre', example: 'María' },
      { key: 'contact.last_name', label: 'Apellido', example: 'González' },
      { key: 'contact.email', label: 'Correo', example: 'maria@acme.com' },
      {
        key: 'contact.phone_number',
        label: 'Teléfono',
        example: '+52 55 1234 5678',
      },
    ],
  },
  {
    key: 'empresa',
    label: 'Empresa',
    icon: 'i-lucide-building-2',
    variables: [
      {
        key: 'empresa.name',
        label: 'Nombre de la empresa',
        example: 'Acme S.A. de C.V.',
      },
      { key: 'empresa.website', label: 'Sitio web', example: 'acme.com' },
      {
        key: 'empresa.email_domain',
        label: 'Dominio de correo',
        example: 'acme.com',
      },
      {
        key: 'empresa.phone_number',
        label: 'Teléfono',
        example: '+52 55 8765 4321',
      },
      { key: 'empresa.notes', label: 'Notas' },
    ],
  },
  {
    key: 'ticket',
    label: 'Ticket',
    icon: 'i-lucide-ticket',
    variables: [
      { key: 'ticket.folio', label: 'Folio', example: 'TKT-2026-0042' },
      { key: 'ticket.title', label: 'Título' },
      { key: 'ticket.description', label: 'Descripción' },
      { key: 'ticket.status', label: 'Estatus', example: 'open' },
      { key: 'ticket.priority', label: 'Prioridad', example: 'high' },
      { key: 'ticket.client_name', label: 'Nombre del cliente' },
      { key: 'ticket.contract_number', label: 'Número de contrato' },
      { key: 'ticket.address_street', label: 'Calle' },
      { key: 'ticket.address_colony', label: 'Colonia' },
      { key: 'ticket.address_postal_code', label: 'Código postal' },
      { key: 'ticket.address_city', label: 'Ciudad' },
      { key: 'ticket.address_state', label: 'Estado' },
    ],
  },
  {
    key: 'document',
    label: 'Documento',
    icon: 'i-lucide-calendar',
    variables: [
      {
        key: 'document.date_long',
        label: 'Fecha (larga)',
        example: '17 de junio de 2026',
      },
      {
        key: 'document.date_short',
        label: 'Fecha (corta)',
        example: '17/06/2026',
      },
      { key: 'document.date_iso', label: 'Fecha (ISO)', example: '2026-06-17' },
      { key: 'document.day', label: 'Día', example: '17' },
      { key: 'document.month', label: 'Mes', example: 'junio' },
      { key: 'document.year', label: 'Año', example: '2026' },
      { key: 'document.account_name', label: 'Nombre de la cuenta' },
    ],
  },
  {
    key: 'account',
    label: 'Cuenta',
    icon: 'i-lucide-settings',
    variables: [{ key: 'account.name', label: 'Nombre de la cuenta' }],
  },
];

export default VARIABLE_CATEGORIES;
